import React, { useState, useEffect } from "react";
import Tab from "../tab/tab";
import TopBar from "../../scenes/global/Top-Bar";
import SideBar from "../../scenes/global/Side-Bar";
import BasicSelect from "../select/select";
import TextInput from "../text_input/text_input";
import $ from "jquery";
import { personal_information, save_personal_details, save_secret, generate_my_cv } from "../../Redux/ActionCreator";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { LanguageContext } from "../../scenes/global/languageContext";
import { v4 as uuidv4 } from 'uuid';


export default function UserPreference(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const info = useSelector(info => info.personal_info);
  const generated = useSelector(e => e.generateCV);
  const profile = useSelector(e => e.login);
  const userInfo = useSelector(e => e.userInfo);
  let stat = profile.profile_status.profile_status;
  const cv = useSelector(prev => prev.cvId);
  const secret = useSelector(prev => prev.secret);


  const [ obj, setObj ] = useState()

    // get the id parameter if any
    const cv_id = useSelector(prev => prev.cvId);
    let id = cv_id.id;

  useEffect(() => {
    if (secret.secret === null) {
      const clientSecret = uuidv4();      
      dispatch(save_secret(clientSecret));
    }
  }, [])

  useEffect(() => {
    if (info.message !== null) {
      $('[name="firstname"]').val(info.message.Firstname);
      $('[name="lastname"]').val(info.message.LastName);
      $('[name="address"]').val(info.message.Address);
      $('[name="email"]').val(info.message.Email);
      $('[name="Country_code"]').val(Number(info.message.Country_code));
      $('[name="phone_number"]').val(Number(info.message.Final_num));
      $('[name="linkedin"]').val(info.message.Linkedin);
      $('[name="website"]').val(info.message.Website);
    } else {
      if (localStorage.getItem("linkedin") !== null) {
        $('[name="linkedin"]').val(localStorage.getItem("linkedin"));
      }
      if (localStorage.getItem("website") !== null) {
        $('[name="website"]').val(localStorage.getItem("website"));
      }
      if (localStorage.getItem("phone_number") !== null) {
        $('[name="website"]').val(localStorage.getItem("phone_number"));
      }
    }
  }, [info.message]);

  useEffect(() => {
    if (window.location.pathname === "/user/profile/update/experience" && profile.message !== null) {
      // setVisibility(true);
      // setwork(profile.message.Experience);
      // setChips(profile.message.Experience);
    } else if (window.location.pathname === `/form/${cv.id}/update`) {
      $('[name="firstname"]').val(generated.message.Fullname);
      $('[name="lastname"]').val(generated.message.LastName);
      $('[name="address"]').val(generated.message.Address);
      $('[name="email"]').val(generated.message.Email);
      $('[name="Country_code"]').val(Number(generated.message.Country_code));
      $('[name="phone_number"]').val(Number(generated.message.Final_num));
      $('[name="linkedin"]').val(generated.message.Linkedin);
      $('[name="website"]').val(generated.message.Website);
    }
  }, []);


  useEffect(() => {
    if (obj !== undefined) {
      dispatch(generate_my_cv(obj));
    }
  }, [obj])


  // const handleClick = () => {
  //   navigate("/generateCV");
  // }
  const handleSaveAndContinue = (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    let final_num;

    if (data.get("countryCode") !== null && data.get("countryCode") !== undefined) {
      final_num = data.get("countryCode") + data.get("phone_number");
    } else {
      final_num = data.get("phone_number");
    }

    const personal_data = {
      Firstname: data.get("firstname"),
      LastName: data.get("lastname"),
      Address: data.get("address"),
      Email: data.get("email"),
      Country_code: data.get("countryCode"),
      Phone_number: Number(final_num),
      Final_num: data.get("phone_number"),
      Linkedin: data.get("linkedin"),
      Website: data.get("website"),
    };
    if (window.location.pathname === `/form/${cv.id}/update`) {
      // if ($('[name="work_place"]').val() !== "") {
      //   handleAdd();
      // }
      let generated_value = generated.message;
      generated_value.Fullname = personal_data.Firstname + " " + personal_data.LastName;
      generated_value.Address = personal_data.Address;
      generated_value.Email = personal_data.Email,
      generated_value.Phone_number = personal_data.Phone_number;
      generated_value.Linkedin = personal_data.Linkedin;
      generated_value.Website = personal_data.Website;
      dispatch(personal_information(personal_data));
      setObj(generated_value);
      navigate("/allCv");
    } else {
      // const Firstname = data.get("firstname");
      // const Lastname = data.get('lastname');
      // const Address = data.get("address");
      // const Phone_number = data.get("phone_number");
      // const Linkedin = data.get("website");
      // const Website = data.get("website");

    if (
      personal_data.Firstname == "" ||
      personal_data.LastName == "" ||
      personal_data.Address == "" ||
      personal_data.Phone_number === ""
    ) {
      let text;
      if (personal_data.Firstname == "") {
        text = "Firstname is required";
      } else if (personal_data.LastName == "") {
        text = "Lastname is required";
      } else if (personal_data.Address == "") {
        text = "Address is required";
      } else if (personal_data.Phone_number == "") {
        text = "Phone number is required";
      }
      setTimeout(() => {
        toast.error(text, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);
    } else {
      console.log("Personal data", personal_data);
      dispatch(personal_information(personal_data));
      // also post to the db
      if (stat === "false" || stat === false) {
        dispatch(save_personal_details(personal_data, id, secret.secret))
      }
      props.handleStepChange();
    }
    }
  }

  const { language, handleLanguageChange } = useContext(LanguageContext);

  return (
    <div className="grid grid-cols-auto md:grid-cols-smdash cont:grid-cols-dash grid-rows-dash">
      <TopBar topBarShowMenu={true} />
      <SideBar /> 
      <div className="px-3 lg:pl-6 my-8 w-full">
        <div className="w-full max-w-[793px] h-[54px] bg-white bg-opacity-50 rounded-[40px] shadow border border-indigo-400 border-opacity-30 flex flex-col justify-center">
          <p className="text-stone-950 text-base md:text-[28px] font-semibold ml-12 max-[300px]:ml-6">
            {language["resume_caph1"]}
          </p>
        </div>
        <p className="w-full max-w-[741px] mt-2">
          <span className="text-black text-opacity-50 text-[14px] md:text-base font-normal">
            {language["heythere_form1"]}
          </span>
          <span className="text-red-500 text-[14px] md:text-base font-normal">
            {" "}
            {language["also_used"]}
          </span>
        </p>
        <div className="max-w-[800px] w-full mt-8 p-8 bg-white bg-opacity-80 rounded-2xl shadow border border-indigo-400 border-opacity-30 flex-col justify-start items-start gap-16 inline-flex">
          <div className="tabarea justify-start items-center gap-6 inline-flex w-full flex-shrink-0 w-full max-w-[calc(100vw-88px)] overflow-hidden">
            <Tab
              // label="Personal Information"
              label={`${language["tab_1"]}`}
              current={true}
              completed={false}
            />
            <Tab num="2" current={false} completed={false} />
            <Tab num="3" current={false} completed={false} />
            <Tab num="4" current={false} completed={false} />
            <Tab num="5" current={false} completed={false} />
            <Tab num="6" current={false} completed={false} />
            <Tab num="7" current={false} completed={false} />
            <Tab num="8" current={false} completed={false} />
            <Tab num="9" current={false} completed={false} />
          </div>
          
          <form onSubmit={handleSaveAndContinue} className="flex-col justify-start items-start gap-12 flex w-full">
          <div className="flex-col justify-start items-start gap-12 flex w-full">
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="firstName"
                >
                 {language["whatsname"]}
                </label>
              </div>
              <TextInput placeholder={`${language["firstName"]}`} id="firstName" name="firstname" />
            </div>
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="lastName"
                >
                  {language["whats_lastname"]}
                </label>
              </div>
              <TextInput  placeholder={`${language["lastname"]}`} id="lastName" name="lastname" onChange={(event) => localStorage.setItem("lastname", event.target.value)} />
            </div>
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label className="text-black text-base font-medium" for="address">
                  {language["whats_address"]}
                </label>
              </div>
              <input
                type="text"
                className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30 focus:outline-indigo-400"
                placeholder={`${language["address_holder"]}`}
                id="address"
                name="address"
              />
            </div>
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label className="text-black text-base font-medium" for="email">
                 {language["whats_email_address"]}
                </label>
              </div>
              <input
                type="email"
                className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30 focus:outline-indigo-400"
                placeholder={`${language["email_here"]}`}
                id="email"
                name="email"
              />
            </div>
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="phoneNumber"
                >
                 {language["whats_phone_number"]}
                </label>
              </div>
              <p className="text-zinc-400 text-base font-medium">
                {/* Enter your phone number and click on "Verify Phone" */}
              </p>
              <div className="w-full flex gap-2">
                <div  className="w-[89px]"><input type="text" className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30" placeholder="+1" labelId="code" name="countryCode" id="countryCode"/></div>
                <div className="w-full"><input type="number" className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30" placeholder="123 456 7890" id="phoneNumber" name="phone_number"  onChange={(event) => localStorage.setItem("phone_number", event.target.value)} /></div>
              </div>
            </div>
              <div className="w-full">
                <div className="flex-col justify-start items-start gap-4 flex w-full">
                  <div className="flex gap-3 items-center">
                    <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                    <p className="text-black text-base font-medium">
                      {language["whats_linkedin"]}
                    </p>
                  </div>
                  <div className="flex flex-col w-full">
                    <label
                      className="text-black text-base font-medium"
                      for="phoneNumber"
                    >
                      {language["linkedin_profile_link"]}
                    </label>
                    <TextInput
                      placeholder={`${language["your_linkedin"]}`}
                      for="phoneNumber"
                      name="linkedin"
                    />
                  </div>
                  <div className="flex flex-col w-full">
                    <label
                      className="text-black text-base font-medium"
                      for="website"
                    >
                      {language["whats_website"]}
                    </label>
                    <TextInput
                      placeholder={`${language["your_website"]}`}
                      for="website"
                      name="website"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="self-stretch flex-col sm:flex-row justify-between items-start gap-4 inline-flex">
              <Link
                className="px-5 py-3 rounded-lg shadow border border-orange-500 justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]" to="/generateCV"
              >
                <span className="text-center text-orange-500 text-base font-semibold">
                  {language["back_templates"]}
                </span>
              </Link>
              <button
                type="submit"
                className="px-5 py-3 bg-indigo-700 rounded-lg shadow justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]"
              >
                <span className="text-center text-white text-base font-semibold whitespace-nowrap">
                  {language["save_n_continue"]}
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}